<div [id]="field.attributes.id" (blur)="touch()">
  @for (option of options; track option; let last = $last) {
  <div class="option">
    <div class="selects">
      <select
        [(ngModel)]="option.variationId"
        (change)="onVariationChange()"
        [disabled]="disabled"
        class="form-select"
      >
        <optgroup placeholder></optgroup>
        @for (variation of associativeGroups[option.group].variations; track
        variation) {
        <option [ngValue]="variation.id">
          {{ variation.value }}
        </option>
        }
      </select>
      <select
        [(ngModel)]="option.group"
        (change)="onGroupChange(option)"
        [disabled]="disabled"
        class="form-select"
      >
        @for (group of groups; track group) {
        <option [ngValue]="group.type">
          {{ group.typeLabel || group.type }}
        </option>
        }
      </select>
    </div>
    @if (!disabled) {
    <array-field-controls
      [canRemove]="canRemove"
      [canAdd]="last"
      (add)="addEmptyOption()"
      (remove)="removeOption(option)"
    ></array-field-controls>
    }
  </div>
  }
</div>
